module.exports = __webpack_public_path__ + "static/tg_logo_red-a59d25118eb1a9096a2d0d175a8912e2.png";